export enum AvailableModalActions {
  SELECT_ACTIONS = 'SELECT_ACTIONS',
  SEND_ERRORS = 'SEND_ERRORS',
  VALIDATE_FAILED = 'VALIDATE_FAILED',
  VALIDATE_OK = 'VALIDATE_OK',
  GENERAL_ERROR = 'GENERAL_ERROR',
}

export interface ActionType {}

export interface Action<TPayload = unknown> {
  type: Actions;
  payload: TPayload;
}

export enum Actions {
  SET_ERROR = 'CM/CASE/PEPPER/SET_ERROR',
}
